export default {
  not_set_up: {
    title: 'Le prenotazioni non sono ancora configurate per questa sede',
    description:
      "Una sede riceve prenotazioni quando è collegata alla sua scheda Google e ha un proprietario. Se il ristorante non ha ancora un proprietario, aggiungine uno in Team. Fino ad allora non ci sono orari di apertura per le prenotazioni da modificare qui, e le modifiche agli orari dell'Online Shop non vengono copiate su Prenotazioni.",
  },
  company_not_loaded: {
    title: 'Impossibile caricare le impostazioni di prenotazione',
    description:
      'Non è stato possibile caricare le impostazioni di prenotazione di questa sede, quindi al momento non è possibile modificarne gli orari di apertura per le prenotazioni. Riprova.',
    retry: 'Riprova',
  },
};
